import { combineReducers } from 'redux';
import clickCollect from './clickCollect';
import clickDeliver from './clickDeliver';
import ibesDelivery from './ibesDelivery';
import products from './products';
import shoppingList from './shoppingList';
import stores from './stores';
import user from './user';
import optimizely from './optimizely';

const dataReducer = combineReducers({
    clickCollect,
    clickDeliver,
    ibesDelivery,
    products,
    shoppingList,
    stores,
    user,
    optimizely,
});

export default dataReducer;
